module.exports = __webpack_public_path__ + "static/media/Cupia-Logo.45ea5642.jpg";